import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Dropdown } from 'react-toolbox';
import TextArea from 'components/TextArea';
import S from '../../TemplateStyling.scss';
import parseMeasurement, { hasDecimalNotation } from './measurementParsing';

const stormDoorConfigTypes = [
  { value: 'Single', label: 'Single' },
  { value: 'Double', label: 'Double' },
];

const sizing = [
  { value: 'Standard', label: 'Standard' },
  { value: 'Custom', label: 'Custom' },
];

function StormDoorMeasures({ measures, onChange }) {
  const handleFieldChange = (idx, field, value) => {
    const updated = measures.map((m, i) =>
      (i === idx ? { ...m, [field]: value } : m),
    );
    onChange(updated);
  };

  const handleNestedChange = (idx, group, subfield, value) => {
    const updated = measures.map((m, i) => {
      if (i === idx) {
        return { ...m, [group]: { ...m[group], [subfield]: value } };
      }
      return m;
    });
    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...measures,
      {
        openingNumber: '',
        configuration: '',
        opening: { width: '', height: '' },
        sizing: '',
        handing: '',
        notes: '',
      },
    ]);
  };

  const removeRow = (idx) => {
    onChange(measures.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <h6>Storm Doors Measured</h6>
      {measures.map((measure, idx) => (
        <div key={measure.openingNumber || `stormDoor-${idx}`} style={{ border: '1px solid #eee', marginBottom: 10, padding: 10 }}>
          <div className={S.container}>
            <strong>ALL MEASURES MUST BE IN INCHES</strong>
            <strong>Opening #{idx + 1}</strong>
          </div>
          <Dropdown label="Configuration" source={stormDoorConfigTypes} value={measure.configuration} onChange={v => handleFieldChange(idx, 'configuration', v)} />
          <strong>MEASUREMENT</strong>
          <Input label="Width" hint="e.g. 34 1/2" value={measure.opening.width} onChange={v => handleNestedChange(idx, 'opening', 'width', v)} />
          <Input label="Height" hint="e.g. 34 1/2" value={measure.opening.height} onChange={v => handleNestedChange(idx, 'opening', 'height', v)} />
          <strong>SIZING</strong>
          <Dropdown label="Standard / Custom" source={sizing} value={measure.sizing} onChange={v => handleFieldChange(idx, 'sizing', v)} />
          <strong>OTHER</strong>
          <Input label="Handing" value={measure.handing} onChange={v => handleFieldChange(idx, 'handing', v)} />
          <TextArea
            label="Notes"
            value={measure.notes || ''}
            onChange={e => handleFieldChange(idx, 'notes', e.target.value)}
          />
          <Button className={S.removeButton} label="Remove" onClick={() => removeRow(idx)} />
        </div>
      ))}
      <Button className={S.button} label="Add Storm Door" onClick={addRow} />
    </div>
  );
}

StormDoorMeasures.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      openingNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      configuration: PropTypes.string,
      opening: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      sizing: PropTypes.string,
      handing: PropTypes.string,
      notes: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StormDoorMeasures;

export function validateStormDoorMeasures(measures) {
  const errors = {};
  measures.forEach((item, idx) => {
    if (item.opening) {
      ['width', 'height'].forEach((subfield) => {
        const value = item.opening[subfield];
        if (value === undefined || value === '') return;
        if (isNaN(parseMeasurement(value))) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`opening.${subfield}`] = [`opening.${subfield} must be a number or fraction.`];
        } else if (hasDecimalNotation(value)) {
          if (!errors[idx]) errors[idx] = {};
          errors[idx][`opening.${subfield}`] = [`opening.${subfield} must not use decimal notation; use a fraction instead (e.g. 34 1/2).`];
        }
      });
    }
  });
  if (Object.keys(errors).length > 0) {
    errors.stormDoorMeasures = [
      'Please ensure all numeric fields are valid numbers.',
    ];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/StormDoorMeasures.jsx